import styled from '@emotion/styled';
import { borderRadii } from '__app/spacing';
import Button from '__components/Button';
import TextInput from '__components/Inputs/TextInput';

export const StyledAddVariableButton = styled(Button)`
  margin: 0;
  margin-top: 2px;
  padding-left: 0;
`;

export const StyledBusinessVariablesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const StyledVariableWarpper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const StyledVariableCard = styled.div<{ hasError: boolean }>`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 15px;
  border: 1px solid
    ${({ hasError }) =>
      hasError
        ? 'var(--color-button-warning-default)'
        : 'var(--color-border-medium)'};
  border-radius: ${borderRadii.small};
`;

export const StyledNameInput = styled(TextInput)`
  width: calc(30% - 10px);
`;

export const StyledValueInput = styled(TextInput)`
  width: calc(70% - 10px);
`;

export const StyledBottomButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
